import React from 'react';
import CameraComponent from './components/Camera';
import './App.css';

function App() {
  return (
    <div className="App">
      <CameraComponent />
    </div>
  );
}

export default App;
